import { render } from "./CountryPositionListPage.vue?vue&type=template&id=7ce79566&scoped=true"
import script from "./CountryPositionListPage.vue?vue&type=script&lang=js"
export * from "./CountryPositionListPage.vue?vue&type=script&lang=js"

import "./CountryPositionListPage.vue?vue&type=style&index=0&id=7ce79566&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ce79566"

export default script